import { hcpAPI } from 'configs/axios';

export const fetchFile = (id: string, signal?: AbortSignal | undefined) => {
  return hcpAPI({
    url: `files/url/${id}`,
    method: 'GET',
    config: {
      signal,
    },
  });
};
